exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-button{background-size:contain;color:#000;text-transform:uppercase;font-size:14pt;border-radius:0;padding:8px 16px;font-weight:700;width:100%;border-radius:8px;border:none;outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d51ba63a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/bora/NewsletterSub.vue
// module id = 87
// module chunks = 0 1 2